<template>
  <div>
    <Input
      search
      placeholder="搜索班级名称"
      v-model="searchKey"
      @on-search="init"
    />
    <Tree :data="datas" show-checkbox @on-check-change="checkItems"></Tree>
  </div>
</template>
<script>
import $axios from "../../utils/axios";
export default {
  name: "YnClass",
  data() {
    return {
      searchKey: "",
      config: JSON.parse(localStorage.getItem("config")),
      datas: [],
      selectList: Object.assign([], this.currentList),
    };
  },
  props: {
    currentList: {
      type: Array,
      default() {
        return [];
      },
    },
    studySectionId: {
      type: String,
      default() {
        return "";
      },
    },
  },
  methods: {
    init() {
      $axios({
        baseURL: this.config.basic,
        url: "studySections/class/byCondition",
        params: {
          studySectionId: this.studySectionId,
          searchKey: this.searchKey,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.datas = res.data;

          if (this.selectList.length > 0) {
            this.datas.forEach((x) => {
              x.children.forEach((b) => {
                b.children.forEach((c) => {
                  var array = this.selectList.find(
                    (a) => a.gradeId == c.nodeId
                  );

                  if (array != undefined && JSON.stringify(array) != "{}") {
                    console.log(JSON.stringify(array));
                    c.checked = true;
                  }
                });
              });
            });
          }
        }
      });
    },
    checkItems(array, item) {
      var list = [];
      array.forEach((x) => {
        if (x.type == "class") {
          list.push({
            classId: x.nodeId,
            className: x.title,
            studySectionId: x.studySectionId,
          });
        }
      });

      this.selectList = Object.assign([], list);
      console.log(JSON.stringify(list));
      this.$emit("classSelect", this.selectList);
    },
  },
  watch: {
    studySectionId(val) {
      if (this.studySectionId.length > 0) {
        this.init();
      }
    },
    currentList(val) {
      this.selectList = Object.assign([], this.currentList);
      this.datas.forEach((x) => {
        x.children.forEach((b) => {
          b.children.forEach((c) => {
            var array = this.selectList.find((a) => a.gradeId == c.nodeId);

            if (array != undefined && JSON.stringify(array) != "{}") {
              console.log(JSON.stringify(array));
              c.checked = true;
            }
          });
        });
      });
    },
  },
};
</script>